<template>
  <div class="xy-absolute-layout" :style="layoutStyle">
    <xyComponent v-for="element in elements" :element="element" :key="element.uuid" :language="props.language" :list-index="props.listIndex" :list-item-data="props.listItemData" />
  </div>
</template>

<script setup>
import { onBeforeMount, ref, computed } from 'vue'
import { info, defaultProps } from './config'
import xyComponent from '@/packages/components/xy-component.vue'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
const elements = ref([])

const layoutStyle = computed(() => {
  if (!props.adaptPhoneHeight) return {}
  // 节点高度（设计稿单位）按宽度比例换算为实际 px，再与屏幕高度比较
  const nodeHeight = Number(props.element?.style?.height) || 0
  const contentWidth = window.innerWidth || 750
  const ratio = contentWidth / 750
  const nodeHeightPx = nodeHeight * ratio
  const screenHeight = window.innerHeight || 1334
  if (screenHeight < nodeHeightPx) {
    return { height: `${screenHeight}px` }
  }
  return {}
})

const setChilderen = (nodes) => {
  if (!nodes || !nodes.length) {
    elements.value = []
    return
  }
  nodes.forEach((node) => {
    node.style = {
      ...node.style,
      position: 'absolute'
    }
  })
  elements.value = nodes
}
onBeforeMount(() => {
  setChilderen(props.element.nodes)
})
</script>

<style lang="scss" scoped>
.xy-absolute-layout {
  display: block;
  position: relative;
  overflow: hidden;
}
</style>
